module.exports = __webpack_public_path__ + "img/c5.95966daa.jpg";